import React from 'react'

interface CanvasAreaIconProps {
  size?: number
  className?: string
}

/**
 * Das Icon des **Bereichs** — in der Werkzeug-Pille ("Bereich platzieren") und
 * im Reiter jedes Bereichs (Figma: `Icon / AppWindow`,
 * Node `5136:46391` in `btn Canvas Toolbar Section` 5136:46218).
 *
 * Violettes Paar — Füllung `#F2F0FF`, Kontur `#6958EE` — analog zum gelben
 * `CanvasNoteIcon` und zum cyanen `CanvasMemoIcon`: Die Farbe
 * kennzeichnet den Werkzeugtyp, nicht einen UI-Zustand, deshalb kein
 * Theme-Token.
 *
 * Default und Hover tragen im Figma dasselbe Glyph (die Füllung unterscheidet
 * sich um ein Haar, `#F2F0FF` vs `#F1EFFF`); der Hover-Zustand ist im Code der
 * Hintergrund der Pille, nicht ein zweites Icon.
 *
 * Die beiden Reiter-Striche sind ein eigener Pfad: Sie wandern beim Überfahren in der
 * Werkzeug-Pille (#315, `_toolbarIconMotion.scss`) — dieselbe Zeichnung, nur in Stücken.
 */
export const CanvasAreaIcon: React.FC<CanvasAreaIconProps> = ({ size = 24, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['canvas-area-icon', className].filter(Boolean).join(' ')}
  >
    <path
      d="M19 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4Z"
      fill="#F2F0FF"
    />
    <g stroke="#6958EE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path className="canvas-area-icon__tabs" d="M11 4V8M7 4V8" />
      <path d="M3 8H21M5 4H19C20.1046 4 21 4.89543 21 6V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V6C3 4.89543 3.89543 4 5 4Z" />
    </g>
  </svg>
)
